import './style.css';
import { initImage } from 'globalCommon/utils/index';
import { syncRender } from 'globalCommon/services/syncRender';
import commonPageService from 'mCommon/services/commonPageService';
import { IMG_SOURCE } from './imagesSource';

function init() {
    commonPageService({ renderAfter: syncRender });
    initImage(IMG_SOURCE);
}

init();
